const development_tenant = {
    notification: '개발 모드입니다',
};
export default Object.freeze(development_tenant);
